import React from 'react'
import Image from 'next/image'
import { Typography, Result } from 'antd'
import styles from './DownLabelItem.module.scss'

const DownLabelItem = (props: any) => {
  const { icon, label1, label2, label3 } = props
  return (
    <>
      <Result
        icon={
          <Image src={icon}
            width={50} height={50}
            alt={`icon-example-${label1}`}
          />
        }
        title={ <h1 className={styles['label']}>{label1}</h1>}
        subTitle={(
          <>
            <Typography.Title level={5} className={styles['label1']}>{label2}</Typography.Title>
            {label3 && <Typography.Title level={5} className={styles['label2']}>{label3}</Typography.Title>}
          </>
        )}
      />
    </>
  )
}

export default DownLabelItem
